<template>
  <v-dialog
    :retain-focus="false"
    max-width="1150px"
    class="dialog"
    :fullscreen="$vuetify.breakpoint.width < 1264"
    v-model="settingDialogVisible"
    @click:outside="close"
    style="height: 100%; overflow: auto"
  >
    <v-row
      no-gutters
      style="background-color: #21343b; justify-content: space-between"
      :class="$vuetify.breakpoint.width < 1264 ? 'px-4 pt-3' : 'pl-10 pr-7 pt-7'"
    >
      <v-col>
        <span class="txt-section-title ml-2">{{ $t('setting') }}</span>
      </v-col>
      <v-col cols="auto">
        <a href="https://taperlabs.notion.site/Knowledge-Base-26f44cc6e0a84d39bc22c143a9f68f54" target="_blank">
          <v-btn v-if="$vuetify.breakpoint.width < 1264" class="mx-0" dark elevation="0" icon>
            <span class="material-icons-round" style="color: #96a7af; font-size: 20px" translate="no">
              question_mark
            </span>
          </v-btn>
        </a>
        <v-btn class="mx-2" dark elevation="0" icon @click="close('Setting')">
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row style="background-color: #21343b; margin: 0" class="pb-2">
      <v-col
        :cols="$vuetify.breakpoint.width < 1264 ? 12 : 'auto'"
        :style="
          $vuetify.breakpoint.width < 1264
            ? 'background-color: #21343b; padding-top: 12px; border-bottom: 1px solid rgba(255, 255, 255, 0.1)'
            : 'background-color: #21343b; padding: 0; border-right: 1px solid rgba(255, 255, 255, 0.1)'
        "
        :class="$vuetify.breakpoint.width < 1264 ? 'mb-3 px-0' : ''"
      >
        <v-navigation-drawer
          style="
            background-color: #21343b;
            padding: 0;
            visibility: visible;
            transform: none;
            box-shadow: none !important;
          "
          :style="
            $vuetify.breakpoint.width < 1264
              ? 'width: 100%; text-align: center; justify: space-between'
              : 'padding: 10px 0 0 10px'
          "
        >
          <v-list nav dense :class="$vuetify.breakpoint.width < 1264 ? 'mx-0' : 'mx-6'" style="height: 100%">
            <v-list-item-group mandatory color="primary" v-model="selected" style="height: 100%">
              <v-list-item
                v-for="(item, i) in items"
                :key="i"
                @click="changeType(item.type)"
                :style="
                  $vuetify.breakpoint.width < 1264
                    ? 'display: inline-block; text-align: center; margin: 0; padding: 0 5px; min-width: 60px'
                    : 'background-color: #21343b; padding-left: 10px'
                "
              >
                <v-list-item-icon
                  :style="
                    $vuetify.breakpoint.width < 1264
                      ? 'padding-top: 5px; margin: 0; padding: 5px 0 0 5px'
                      : 'margin: 10px'
                  "
                >
                  <!-- <v-icon v-text="item.icon"></v-icon> -->
                  <span
                    class="material-icons-round mr-1"
                    style="font-size: 25px"
                    translate="no"
                    v-text="item.icon"
                  ></span>
                </v-list-item-icon>
                <v-list-item-content v-if="!$vuetify.breakpoint.width < 1264">
                  <v-list-item-title v-text="item.text" style="min-height: 10px"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <a href="https://taperlabs.notion.site/Knowledge-Base-26f44cc6e0a84d39bc22c143a9f68f54" target="_blank">
                <v-list-item
                  v-if="$vuetify.breakpoint.width >= 1264"
                  style="position: absolute; width: 100%; bottom: 30px"
                  plain
                  active-class="active-list-item"
                >
                  <v-list-item-icon style="margin-right: 5px">
                    <span
                      class="material-icons-round"
                      style="color: #96a7af; font-size: 20px; margin: 2px 13px"
                      translate="no"
                    >
                      question_mark
                    </span>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title style="min-height: 10px">Help</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </a>
            </v-list-item-group>
          </v-list>
        </v-navigation-drawer>
      </v-col>
      <v-col
        :cols="$vuetify.breakpoint.width < 1264 ? 12 : 9"
        :style="
          $vuetify.breakpoint.width < 1264
            ? 'padding: 0; background-color: #21343b; height: calc(100vh - 151px) !important; overflow: auto'
            : 'padding: 0; background-color: #21343b; overflow: auto; height: 80vh; max-height: 700px'
        "
      >
        <account-setting class="setting-detail" v-if="type === 'ACCOUNT'" @close="close"></account-setting>
        <workspace-setting
          class="setting-detail"
          v-if="type === 'WORKSPACE' && $store.getters.selectedWsInfo"
          @openAdd="openSlot"
          @openDialog="openDialog"
          @openManage="openManage"
          @close="close"
        ></workspace-setting>
        <noti-setting
          class="setting-detail"
          @close="close"
          v-if="type === 'NOTI' && $store.getters.selectedWsInfo"
        ></noti-setting>
        <plan-setting
          class="setting-detail"
          v-if="type === 'PLANBILLING' && $store.getters.selectedWsInfo"
          @close="close"
        ></plan-setting>
        <billing-setting
          class="setting-detail"
          v-if="type === 'BILLING' && $store.getters.selectedWsInfo"
        ></billing-setting>
      </v-col>
    </v-row>
  </v-dialog>
</template>

<script>
import AccountSetting from '@/views/modal/component/AccountSetting'
import WorkspaceSetting from '@/views/modal/component/WorkspaceSetting'
import NotiSetting from '@/views/modal/component/NotiSetting'
import { isMobile } from '@/common/lib/strLib'
import PlanSetting from '@/views/modal/component/PlanSetting.vue'
import BillingSetting from '@/views/modal/component/BillingSetting.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'Settings',
  components: { NotiSetting, WorkspaceSetting, AccountSetting, PlanSetting, BillingSetting },
  created() {
    this.dialogTableVisible = this.settingVisible
    this.settingDialogVisible = this.settingVisible
    if (this.$store.getters.selectedWsInfo) {
      this.items.push(
        { text: 'Account', type: 'ACCOUNT', icon: 'account_circle' },
        { text: 'Notification', type: 'NOTI', icon: 'notifications' },
        { text: 'Workspace', type: 'WORKSPACE', icon: 'workspaces' },
        { text: 'Plan', type: 'PLANBILLING', icon: 'price_change' }
      )
      if (this.isWsOwner) {
        this.items.push({ text: 'Billing', type: 'BILLING', icon: 'payment' })
      }
    } else {
      this.items.push({ text: 'Account', type: 'ACCOUNT', icon: 'mdi-account' })
    }

    if (this.menuType && this.menuType !== null && this.menuType !== '') {
      this.$store.dispatch('setOpenPref', null)
      switch (this.menuType) {
        case 'ACCOUNT':
          this.selected = 0
          break
        case 'NOTI':
          this.selected = 1
          break
        case 'WORKSPACE':
          this.selected = 2
          break
        case 'PLANBILLING':
          this.selected = 3
          break
        case 'BILLING':
          this.selected = 4
      }
      this.selected
      this.changeType(this.menuType)
    }
  },
  props: {
    settingVisible: Boolean,
    menuType: String,
    // isSettingDialog: Boolean,
  },
  data() {
    return {
      dialogTableVisible: false,
      wsLogo: '',
      type: 'ACCOUNT',
      wsInfo: this.$store.getters.selectedWsInfo,
      userInfo: this.$store.getters.userInfo,
      items: [],
      selected: 0,
    }
  },
  // computed: {
  //   settingDialogVisible: {
  //     get() {
  //       return this.isSettingDialog
  //     },
  //     set(isSettingDialog) {
  //       this.$emit('input', isSettingDialog)
  //     },
  //   },
  // },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    },
    changeType(type) {
      this.type = type
    },
    openManage() {
      this.$emit('openManage', 'Manage')
    },
    openSlot() {
      this.$emit('openSlot', 'Slot')
    },
    close() {
      this.$emit('close', 'Setting')
    },
    openDialog(event) {
      this.$emit('openManage', event)
    },
  },
  computed: {
    isMobile() {
      return isMobile()
      // return true
    },
    ...mapGetters(['selectedWsInfo', 'isWsOwner', 'isWsManager']),
  },
}
</script>

<style scoped>
.txt-section-title {
  font-weight: 700;
  font-size: 18px;
  color: white;
  align-self: center;
}
.active_primary {
  background: #25c685;
  border-color: #25c685;
  color: #fff;
}

.setting-detail >>> .dis_primary {
  background: #d4f5e9;
  border-color: #d4f5e9;
  color: #25c685;
}

.setting-detail >>> .dis_primary:hover {
  background: #d4f5e9;
  border-color: #d4f5e9;
  color: #25c685;
}

.v-dialog__content >>> .v-dialog {
  border-radius: 24px;
  overflow: hidden;
}

.theme--light.v-list-item:not(.v-list-item--active) >>> .v-list-item__title {
  color: #96a7af !important;
}

.theme--light.v-list-item:not(.v-list-item--active) >>> .v-list-item__icon {
  color: #96a7af !important;
}

.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #25c685 !important;
  color: #ffffff !important;
}

.active-list-item::before {
  opacity: 0 !important;
}
</style>
